export const PURCHASE = "1";
export const REFINANCE = "2";

export default Object.freeze({
  [PURCHASE]: "Purchase",
  [REFINANCE]: "Refinance"
});
